<template>
  <div>
		<div class="coachee_status">
			<div class="row page-heading mx-0">
                <div class="col-8 input module_heading">
                    <span class="module_icon icon-user" style="color: #157099;"></span>
                    <span class="module_type_name">Subscriber Status</span>
                </div>
                <div class="col-4 submit btn-container text-right">
                </div>
            </div>

			<div id="coacheePopover" class="coacheePopover questPopover"></div>

			<div class="data_row_container">

				<div class="row data_row" v-for="(coachee, index) in coachees">

					<div class="username_and_progress_container">

						<div class="user_detail">
							<div class="thumbnail">
								<div class="icon icon-user"></div>
							</div>
							<div class="username_section">
                                <span class="username" :id="'coachee_' + index">{{coachee.userName}}</span>
                                <span v-if="formattedReminders[coachee.userId]" class="exclamation-circle" v-b-popover.hover="'You have a reminder!'">
                                	<span class="ico-error"></span>
                                </span>
							</div>
							<!--
							<b-popover :target="'coachee_' + index" container="coacheePopover" triggers="hover focus" placement="topright">
								 <div class="cont-sec">{{coachee.userName}}</div>
							</b-popover>
							-->
						</div>

						<div class="progress-bar-sec" v-if="formattedQuestStatus[coachee.userId]">
							<div class="count-value" v-if="formattedQuestStatus[coachee.userId].completed === 0">0</div>
							<div class="count-value" v-else>{{formattedQuestStatus[coachee.userId].completed}}</div>
							<div class="progress"></div>
							<b-progress-bar  :max="currentStudentQuests(coachee.userId).length" :value="formattedQuestStatus[coachee.userId].completed"></b-progress-bar>
						</div>

					</div>

					<div class="quest_details_container">

						<!--
						<div class="quest_row">
							Start Date : Apr 10, 2019
						</div>
						-->

						<div class="quest_row">
							<span class="quest_col">
								<span class="ic icon-job"></span>
								<span class="count-title">
									<span class="count" v-if="formattedCareerIdeas[coachee.userId]">{{formattedCareerIdeas[coachee.userId].careerIdeaCount}}</span>
									<span class="title">Career Idea</span>
								</span>
							</span>
							<span class="quest_col">
								<span class="ic ico-connection1"></span>
								<span class="count-title">
									<span class="count" v-if="formattedCareerIdeas[coachee.userId]">{{formattedCareerIdeas[coachee.userId].connectionCount}}</span>
									<span class="title">Connection</span>
								</span>
							</span>
							<span class="quest_col">
								<span class="ic ico-conversation"></span>
								<span class="count-title">
									<span class="count" v-if="formattedCareerIdeas[coachee.userId]">{{formattedCareerIdeas[coachee.userId].conversationCount}}</span>
									<span class="title">Conversations</span>
								</span>
							</span>
						</div>

					</div>
					<!--
					<div id="questblockPopup" class="quest-block-popup"></div>
					-->

					<div class="quest_block_container grid_view">
			            <template v-for="(quest, index) in currentStudentQuests(coachee.userId)">
			              	<div class="quest_status_block" :class="statusClass(quest.status)">
		                        <template v-if="quest.status === -1">
		                        	<span class="ic ico-lock"></span>
									<span class="quest_name">{{quest.titleForStudent}}</span>
									<!--
									<span class="quest_name" :id="coachee.userId + index" variant="primary">{{quest.titleForStudent}}</span>
									-->
		                        </template>
		                        <template v-if="quest.status !== -1">
								  <span v-if="quest.status === 1" style="color: #1e7296;" class="ic ico-continue"></span>
								  <span v-if="quest.status === 0" class="quest_name" @click="generateReport(quest, coachee.userName, $event.target)">{{quest.titleForStudent}}</span>
								  <span v-if="quest.status === 1" style="color: #c5a112;" class="quest_name" @click="generateReport(quest, coachee.userName, $event.target)">{{quest.titleForStudent}}</span>
								  <span v-if="quest.status === 2" style="color: rgb(79, 143, 0);" class="quest_name" @click="generateReport(quest, coachee.userName, $event.target)">{{quest.titleForStudent}}</span>
								  <span v-if="quest.status === -1" class="quest_name" @click="generateReport(quest, coachee.userName, $event.target)">{{quest.titleForStudent}}</span>

		                        </template>
			  				</div>

			  				<!--
			  				<b-popover :target="coachee.userId + index"  container="questblockPopup" triggers="hover focus">
		  						<div class="title">
		  							<span class="icon-assessment"></span>
		  							<span class="hd_txt">{{quest.titleForStudent }}</span>
		  						</div>
		  						<div class="content-section">

		  							<div class="content-row">
		  								<div class="title-label" style="width: 55px;">Status:</div>
		  								<div class="result-label">
			  								<span v-if="quest.status === -1">Locked</span>
				  							<span v-if="quest.status === 0">Unlocked</span>
				  							<span v-if="quest.status === 1">In-Progress</span>
				  							<span v-if="quest.status === 2">Done</span>
		  								</div>
		  							</div>

		  							<div v-if="quest.status === 0">
			  							<div class="content-row">
			  								<div class="icon ico-dateRange"></div>
			  								<div class="title-label">Unlocked:</div>
			  								<template v-if="quest.unlockedTime > 0">
                                               <div class="result-label">{{changeMillisToDate(quest.unlockedTime)}}</div>
                                            </template>
                                            <template v-else>
                                               <div class="result-label">xx/xx/xxxx</div>
                                            </template>
			  							</div>

			  							<div v-if="quest.status === 1">
				  							<div class="content-row">
				  								<div class="icon ico-dateRange"></div>
				  								<div class="title-label">Started:</div>
				  								<template v-if="quest.startTime > 0">
                                                   <div class="result-label">{{changeMillisToDate(quest.startTime)}}</div>
                                                </template>
                                                <template v-else>
                                                   <div class="result-label">xx/xx/xxxx</div>
                                                </template>
				  							</div>
				  							<div class="content-row">
				  								<div class="icon ico-dateRange"></div>
				  								<div class="title-label">Completed:</div>
				  								<div class="result-label">xx/xx/xxxx</div>
				  							</div>
				  							<div class="content-row">
				  								<div class="title-label">Reviewed</div>
				  								<div class="result-label"></div>
				  							</div>
			  							</div>

			  							<div v-if="quest.status === 2">
				  							<div class="content-row">
				  								<div class="icon ico-dateRange"></div>
				  								<div class="title-label">Started:</div>
				  								<template v-if="quest.startTime > 0">
                                                   <div class="result-label">{{changeMillisToDate(quest.startTime)}}</div>
                                                </template>
                                                <template v-else>
                                                   <div class="result-label">xx/xx/xxxx</div>
                                                </template>
				  							</div>
				  							<div class="content-row">
				  								<div class="icon ico-dateRange"></div>
				  								<div class="title-label">Completed:</div>
				  								<template v-if="quest.endTime > 0">
                                                   <div class="result-label">{{changeMillisToDate(quest.endTime)}}</div>
                                                </template>
                                                <template v-else>
                                                   <div class="result-label">xx/xx/xxxx</div>
                                                </template>
				  							</div>
				  							<div class="content-row">
				  								<div class="title-label">Reviewed</div>
				  								<div class="result-label"></div>
				  							</div>
			  							</div>
		  							</div>

		  						</div>
		  					</b-popover>
		  					-->

			            </template>
					</div> <!-- .quest_block_container -->


					<div class="row_btn_container">

						<div class="current_quest_details">
							<!--
							<div id="questTitlePopover" class="quest-title-popover"></div>
							-->
							<div class="quest_row current_quest" v-if="formattedQuestStatus[coachee.userId]">
								<span class="label">Current Quest: </span>
								<span class="ico-continue"></span>
								<span class="val" id="questTitle" :title="formattedQuestStatus[coachee.userId].currentQuest" >{{formattedQuestStatus[coachee.userId].currentQuest}}</span>
								<!--
								<b-popover target="questTitle" :title="formattedQuestStatus[coachee.userId].currentQuest" container="questTitlePopover" triggers="click"></b-popover>
								-->
							</div>
						</div>

						<div class="change_view" :id="'changeView_' + coachee.userId">
							<button class="ic_list" @click="showDetailView(coachee.userId, coachee)">show details</button>
	            			<button class="ic_list" @click="unlockNextQuest(coachee.userId)" style="margin-left: 10px;">review completed/unlock next quest</button>
							<button class="ic_grid" @click="hideDetailView(coachee.userId)">hide details</button>
						</div>

					</div>



					<div class="quest_block_container list_view" :id="'coachee_' + coachee.userId">

						<!--
						<div class="header">
		            		<div class="quest_no">Quest No.</div>
		            		<div class="quest_name">Quest Name</div>
		            		<div class="popup_info">
		            			<div class="start_date">Start Date</div>
		            			<div class="submit_date">Submission Date</div>
		            			<div class="status">Status</div>
		            		</div>
		            		<div class="visibility"></div>
		            	</div>
						-->

			            <template v-for="quest in currentStudentQuests(coachee.userId)">
			              	<div class="quest_status_block row" :class="statusClass(quest.status)">
			              		<div class="col-5">
				              		<div class="quest_name" v-b-popover.hover.top="quest.titleForStudent" variant="primary" @click="generateReport(quest, coachee.userName, $event.target)">
				              			<span class="icon-assessment"></span>
				  						<div>{{quest.titleForStudent}}</div>
				  					</div>
				  					<div class="status second_row">
			  							<span class="label">Status: </span>
			  							<span class="val">
				  							<span v-if="quest.status === -1">Locked</span>
				  							<span v-if="quest.status === 0">Unlocked</span>
				  							<span v-if="quest.status === 1">In-Progress</span>
				  							<span v-if="quest.status === 2">Done</span>
			  							</span>
			  						</div>
			              		</div>

			  					<div class="col-3">
			  						<div v-if="quest.status === -1">
				  						<div class="date">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Unlocked:</span>
				  							<template v-if="quest.unlockedTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date second_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Started:</span>
				  							<span class="no_val">xx/xx/xxxx</span>
				  						</div>
				  						<div class="date third_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Completed:</span>
				  							<span class="no_val">xx/xx/xxxx</span>
				  						</div>
			  						</div>

			  						<div v-if="quest.status === 0">
				  						<div class="date">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Unlocked:</span>
				  							<template v-if="quest.unlockedTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date second_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Started:</span>
				  							<span class="no_val">xx/xx/xxxx</span>
				  						</div>
				  						<div class="date third_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Completed:</span>
				  							<span class="no_val">xx/xx/xxxx</span>
				  						</div>
			  						</div>

			  						<div v-if="quest.status === 1">
				  						<div class="date">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Unlocked:</span>
				  							<template v-if="quest.unlockedTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date second_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Started:</span>
				  							<template v-if="quest.startTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.startTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date third_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Completed:</span>
				  							<span class="no_val">xx/xx/xxxx</span>
				  						</div>
			  						</div>

			  						<div v-if="quest.status === 2">
				  						<div class="date">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Unlocked:</span>
				  							<template v-if="quest.unlockedTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.unlockedTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date second_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Started:</span>
				  							<template v-if="quest.startTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.startTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
				  						<div class="date third_row">
				  							<span class="icon ico-dateRange"></span>
				  							<span class="label">Completed:</span>
				  							<template v-if="quest.endTime > 0">
                                               <span class="val">{{changeMillisToDate(quest.endTime)}}</span>
                                            </template>
                                            <template v-else>
                                               <span class="no_val">xx/xx/xxxx</span>
                                            </template>
				  						</div>
			  						</div>
			  					</div>

			  					<div class="col-2">
			  					</div>

			  					<div class="col-2">
			  						<div class="visibility ic icon-visibility" v-if="quest.status !== -1"></div>
			                		<div class="visibility ic icon-visibility_off" v-if="quest.status === -1" @click="unlockQuest(quest.userId, quest.courseId, quest.entityId)" v-b-popover.hover.top="'click to unlock quest'"></div>
			                	</div>
			  				</div>
			            </template>
					</div> <!-- .quest_block_container -->

				</div> <!-- .data_row -->

			</div>

		</div>

		<b-modal class="page_modal" id="attemptReportInfo" size="xlg" centered :title="knowledgeCheckReportTitle" @hidden="showAttemptReport = false" hide-footer>
			<template v-if="showAttemptReport">
				<div slot="modal-header" class="header-section">
					<div class="popup-heading">{{knowledgeCheckReportTitle}}</div>
					  <button class="btn_close" aria-label="close" @click="closeAttemptReport">
                         <span class="ic-close"></span>
                      </button>
				</div>

				<div class="popup_inner_content">
					<class-activity-outcome :activity-outcome-parameter="activityOutcomeParameter">
					</class-activity-outcome>
				</div>
			</template>
		</b-modal>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ClassActivityOutcome from '../../assessment/components/ClassActivityOutcome'
import { DateTime } from 'luxon'

export default {
  name: 'coacheeTracker',
  props: [],
  components: {
    ClassActivityOutcome
  },
  data: () => {
    return {
      showLoader: false,
      name: '',
      coachees: [],
      quests: [],
      formattedQuests: {},
      formattedQuestStatus: {},
      formattedCareerIdeas: {},
      formattedReminders: {},
      showAttemptReport: false,
      activityOutcomeParameter: {},
      knowledgeCheckReportTitle: ''
    }
  },

  mounted () {
    this.loadCoacheeTracker()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadCoacheeStatus',
      'loadCoachees',
      'loadUnlockQuest',
      'loadCareerIdeasForUser',
      'loadAssessmentAttemptForClass',
      'loadCoacheesCareerIdeas',
      'loadNote'
    ]),
    loadCoacheeTracker () {
      this.loadCoachees({name: ''}).then(res => {
        this.coachees = res.advisees
        this.loadCoacheeCareerIdeas()
        this.loadCoacheeReminders()
        this.loadCoacheeStatus().then(res => {
          this.quests = res
          this.loadCoacheeQuests()
        })
      })
    },
    loadCoacheeCareerIdeas () {
      this.loadCoacheesCareerIdeas().then(res => {
        this.formattedCareerIdeas = res
      })
    },
    loadCoacheeReminders () {
      for (var i = 0; i < this.coachees.length; i++) {
        this.formattedReminders[this.coachees[i].userId] = false
        this.loadNote({coacheeId: this.coachees[i].userId, type: 'reminder'}).then(res => {
          if (res) {
            var today = new Date()
            var reminderDate = new Date(res.reminderDate)
            if (reminderDate.getTime() <= today.getTime()) {
              this.formattedReminders[res.coacheeUuid] = true
            }
          }
        })
      }
    },
    loadCoacheeQuests () {
      var users = {}
      var usersQuestStatus = {}
      for (var i = 0; i < this.quests.length; i++) {
        var currentQ = this.quests[i]
        if (!users[currentQ.userId]) {
          users[currentQ.userId] = []
          usersQuestStatus[currentQ.userId] = {
            'completed': 0,
            'currentQuest': 'Not yet started'
          }
        }

        if ((currentQ.status >= 2) && (currentQ.order > 1)) {
          usersQuestStatus[currentQ.userId].completed = usersQuestStatus[currentQ.userId].completed + 1
          usersQuestStatus[currentQ.userId].currentQuest = currentQ.titleForStudent
        }

        if (currentQ.status === 1) {
          usersQuestStatus[currentQ.userId].currentQuest = currentQ.titleForStudent
        }
        users[currentQ.userId].push(currentQ)
      }
      this.formattedQuests = users
      this.formattedQuestStatus = usersQuestStatus
    },
    currentStudentQuests (userId) {
      return this.formattedQuests[userId]
    },
    statusClass (status) {
      if (status === -1) {
        return 'status_locked'
      } else if (status === 0) {
        return 'status_unlocked'
      } else if (status === 1) {
        return 'status_in_progress'
      } else { // 2 or 3
        return 'status_done'
      }
    },
    unlockNextQuest (userId) {
      let quests = this.formattedQuests[userId]
      var lastCompletedQuestIndex = -1
      var questToBeUnlocked = {}
      var extraQuestToBeUnlocked = {}
      for (var i = 0; i < quests.length; i++) {
        if (quests[i].status === 2) {
          lastCompletedQuestIndex = i
        }
      }
      if (lastCompletedQuestIndex === -1) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Previous quest still not complete. Cannot open next quest.'
        })
      } else if (lastCompletedQuestIndex < quests.length - 1) {
        questToBeUnlocked.courseId = quests[lastCompletedQuestIndex + 1].courseId
        questToBeUnlocked.entityId = quests[lastCompletedQuestIndex + 1].entityId
        questToBeUnlocked.titleForStudent = quests[lastCompletedQuestIndex + 1].titleForStudent
        questToBeUnlocked.status = quests[lastCompletedQuestIndex + 1].status
        if (questToBeUnlocked.titleForStudent.indexOf('Q5') > -1) {
          extraQuestToBeUnlocked.courseId = quests[lastCompletedQuestIndex + 2].courseId
          extraQuestToBeUnlocked.entityId = quests[lastCompletedQuestIndex + 2].entityId
        }
        if (questToBeUnlocked.status === -1) {
          this.unlockQuest(userId, questToBeUnlocked.courseId, questToBeUnlocked.entityId)
          if (extraQuestToBeUnlocked.entityId) {
            this.unlockQuest(userId, extraQuestToBeUnlocked.courseId, extraQuestToBeUnlocked.entityId)
          }
          this.loadCoacheeTracker()
        } else {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Next quest already unlocked!'
          })
        }
      }
    },
    unlockQuest (userId, courseId, entityId) {
      this.loadUnlockQuest({userId: userId, courseId: courseId, contentId: entityId}).then((res) => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Quest Successfully Unlocked!'
        })
      })
    },
    generateReport (quest, userName) {
      let user = {}
      user[quest.userId] = userName
      let users = [user]
      this.loadAssessmentAttemptForClass({assessmentId: quest.entityId, users: users}).then(res => {
        if (res && res.length > 0 && res[0].attempt1) {
          this.showAttemptReport = true
          this.activityOutcomeParameter['userId'] = res[0].userId
          this.activityOutcomeParameter['courseId'] = quest.courseId
          this.activityOutcomeParameter['sessionId'] = res[0].attempt1.sessionId
          this.activityOutcomeParameter['activityId'] = res[0].attempt1.activityId
          if (res[0].attempt1.isCompleted) {
            this.activityOutcomeParameter['isCompleted'] = res[0].attempt1.isCompleted
          } else {
            this.activityOutcomeParameter['isCompleted'] = (res[0].attempt1.status === 2)
          }
          this.activityOutcomeParameter['manuallyGraded'] = res[0].attempt1.manuallyGraded
          this.knowledgeCheckReportTitle = 'Quest Report - ' + res[0].name
          this.$root.$emit('bv::show::modal', 'attemptReportInfo', null)
        }
      })
    },
    showDetailView (userId, coachee) {
      return this.$router.push({ name: 'coacheeDetail', params: { uuid: userId, user: coachee, careerIdeaCount: this.formattedCareerIdeas[userId].careerIdeaCount, connectionCount: this.formattedCareerIdeas[userId].connectionCount, conversationCount: this.formattedCareerIdeas[userId].conversationCount } })
      /*
      $('#coachee_' + rowId).show()
      $('#changeView_' + rowId + ' .ic_list').hide()
      $('#changeView_' + rowId + ' .ic_grid').show()
      */
    },
    hideDetailView (rowId) {
      $('#coachee_' + rowId).hide()
      $('#changeView_' + rowId + ' .ic_list').show()
      $('#changeView_' + rowId + ' .ic_grid').hide()
    },
    closeAttemptReport () {
      this.$root.$emit('bv::hide::modal', 'attemptReportInfo')
    },
    changeMillisToDate (selected) {
      if (selected) {
        return DateTime.fromMillis(selected, {zone: 'utc'}).toFormat('MM/dd/yyyy')
      }
      return null
    }
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  }
}
</script>

<style lang="scss"
  src="../../../assets/module/sass/adviseeTracker/adviseeDetails.scss">
    @media (min-width: 900px) {
        .modal .modal-xlg {
            max-width: 80% !important;
            width: 80% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/coacheeTracker/components/CoacheeTracker.vue